import { useDuplicateQuestionMutation } from '@exam-management/graphql';
import { useParams, useNavigate } from '@exam-management/router';
import { Dialog, DialogTitle, Divider } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

import { type QuestionDuplicationFormInput, QuestionDuplicationForm } from '../../components';

interface QuestionDuplicationModalProps {
  open: boolean;
  onClose: () => void;
  qId: string;
  qContentId: string;
}

export default function QuestionDuplicationModal(props: Readonly<QuestionDuplicationModalProps>) {
  const { open: isOpen, onClose, qId, qContentId } = props;
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { structureId } = useParams('/qbank-structures/:structureId');

  const [duplicateQuestion, { loading: isDuplicatingQuestion }] = useDuplicateQuestionMutation({
    onCompleted: (duplicatedQuestion) => {
      showSnackbar({
        message: 'Question Duplicated',
        variant: 'success',
      });
      navigate(`/qbank-structures/:structureId/qcontents/single/:contentId`, {
        params: {
          structureId: structureId,
          contentId: duplicatedQuestion.qctDuplicateQuestion.id,
        },
      });
    },
    onError: () => {
      showSnackbar({
        message: 'Unable to Duplicate Question',
        variant: 'error',
      });
    },
  });

  const handleSubmit = async (data?: QuestionDuplicationFormInput) => {
    await duplicateQuestion({
      variables: {
        input: {
          questionId: qContentId,
          qBankStructureLevelItemId: data?.SUB_TOPIC?.value,
        },
      },
    });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth='sm'>
      <DialogTitle>Duplicate Question</DialogTitle>
      <Divider />
      <QuestionDuplicationForm
        onSubmit={handleSubmit}
        onClose={onClose}
        qId={qId}
        qContentId={qContentId}
        loading={isDuplicatingQuestion}
      />
    </Dialog>
  );
}
